import { createReducer } from '@reduxjs/toolkit'

import { automationProfilesTableColumnsConfig } from 'configuration/tables/automationTable'
import { AUTOMATIONS, AUTOMATION_PROFILE_NAME } from 'const/filters'
import { FILTER_SETTINGS, LOCAL_FILTERS } from 'const/reducerKeys'
import { serializeColumns } from 'helpers/tables'
import { defaultTab, getDefaultTable } from 'reducers/ui/defaults'

const initialState = {
    ...defaultTab,
    [LOCAL_FILTERS]: {
        [AUTOMATION_PROFILE_NAME]: null,
        [AUTOMATIONS]: [],
    },
    [FILTER_SETTINGS]: {
        anchored: [AUTOMATION_PROFILE_NAME],
        order: [AUTOMATIONS],
        displayState: {
            [AUTOMATIONS]: true,
        },
    },
    table: getDefaultTable(
        serializeColumns(automationProfilesTableColumnsConfig),
        {
            sorter: {
                field: ['created_at'],
                order: 'descend',
            },
        }
    ),
}

export default createReducer(initialState, () => {})
